module.exports = __webpack_public_path__ + "img/341.ec8d4602.jpg";